import { Controller } from '@hotwired/stimulus'
import {
  analyticsDisabled,
  kelvinAnalytics,
  pageProperties,
  respectingConsent
} from '../lib/tracking_utils'

export default class extends Controller {
  static values = {
    consentGiven: { type: Boolean, default: false },
    sendPageView: { type: Boolean, default: false },
    sendIdentify: { type: Boolean, default: false },
    currentUserId: { type: String }
  }

  async initAnalytics () {
    respectingConsent(async () => {
      if (analyticsDisabled()) {
        return
      }

      this.analytics = await kelvinAnalytics()

      this.doIdentify()
      this.trackPageView()
    })
  }

  connect () {
    this.initAnalytics()
  }

  consentGivenValueChanged () {
    if (this.consentGivenValue) {
      this.initAnalytics()
    }
  }

  doIdentify () {
    respectingConsent(() => {
      if (this.sendIdentifyValue && this.currentUserIdValue && this.analytics) {
        this.analytics.identify(this.currentUserIdValue)
      }
    })
  }

  trackPageView () {
    respectingConsent(() => {
      if (this.sendPageViewValue && this.analytics) {
        const pageName = document.querySelector('meta[name="analytics-page-name"]')?.getAttribute('content')
        this.analytics.page({ name: pageName, ...pageProperties() })
      }
    })
  }

  trackEvent (event) {
    respectingConsent(() => {
      if (!this.analytics) return

      const target = event.currentTarget
      const eventName = target.dataset.analyticsEventNameParam
      if (!eventName) return

      const customProps = this.#parseCustomProperties(target)
      const properties = { ...pageProperties(), ...customProps }

      this.analytics.track(eventName, properties)
    })
  }

  #parseCustomProperties (target) {
    const propsJson = target.dataset.analyticsEventPropertiesParam
    if (!propsJson) return {}
    try {
      return JSON.parse(propsJson)
    } catch {
      return {}
    }
  }
}
